import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, MapPin } from "lucide-react";
import api from "../lib/api";
import { imgUrl } from "../components/ExperienceCard";

const KIND_LABEL = {
    adresse: "Adresse",
    balade: "Balade",
    experience: "Expérience",
    detour: "Détour",
};

export default function ParcoursDetail() {
    const { slug } = useParams();
    const [pc, setPc] = useState(null);
    const [error, setError] = useState("");

    useEffect(() => {
        setPc(null); setError("");
        api.get(`/parcours/${slug}`).then((r) => setPc(r.data)).catch(() => setError("Parcours introuvable."));
    }, [slug]);

    if (error) return <div className="pt-40 text-center pb-40"><h1 className="cp-serif text-5xl">{error}</h1><Link to="/parcours" className="cp-btn-ghost mt-10 inline-flex">Retour</Link></div>;
    if (!pc) return <div className="pt-40 text-center text-cp-gris">Chargement…</div>;

    return (
        <div data-testid={`parcours-detail-${slug}`}>
            <section className="relative min-h-[75vh] overflow-hidden">
                <img src={imgUrl(pc.image)} alt={pc.title} className="absolute inset-0 w-full h-full object-cover cp-kenburns cp-photo-warm" />
                <div className="absolute inset-0 cp-hero-overlay" />
                <div className="relative z-10 flex flex-col justify-end min-h-[75vh] px-6 md:px-12 py-20 max-w-[1600px] mx-auto">
                    <Link to="/parcours" className="cp-tiny text-cp-ivoire/70 hover:text-cp-ivoire flex items-center gap-2 mb-6">
                        <ArrowLeft size={14} strokeWidth={1.25} /> Parcours
                    </Link>
                    <p className="cp-tiny text-cp-sable mb-4">{pc.theme} · {pc.duration}</p>
                    <h1 className="cp-serif text-cp-ivoire text-3xl sm:text-4xl md:text-5xl lg:text-[56px] xl:text-[72px] leading-[1.05] max-w-4xl tracking-[-0.02em]">
                        {pc.title}
                    </h1>
                    <p className="cp-serif italic text-cp-ivoire/90 text-xl md:text-2xl font-light leading-snug mt-8 max-w-3xl">{pc.tagline}</p>
                </div>
            </section>

            <section className="px-6 md:px-12 max-w-[1400px] mx-auto py-24 grid grid-cols-1 md:grid-cols-12 gap-12">
                <aside className="md:col-span-4 flex flex-col gap-8">
                    <div><p className="cp-tiny text-cp-foret mb-2">Durée</p><p className="cp-serif text-2xl">{pc.duration}</p></div>
                    {pc.total_distance_km && <div><p className="cp-tiny text-cp-foret mb-2">Distance</p><p className="cp-serif text-2xl">{pc.total_distance_km} km</p></div>}
                    {pc.best_season && <div><p className="cp-tiny text-cp-foret mb-2">Meilleure saison</p><p className="cp-serif italic text-xl">{pc.best_season}</p></div>}
                </aside>
                <div className="md:col-span-8">
                    <p className="text-cp-encre text-xl md:text-2xl font-light leading-relaxed whitespace-pre-line mb-12">{pc.description}</p>

                    <p className="cp-tiny text-cp-foret mb-6">Le parcours · {pc.stops?.length} étapes</p>
                    <div className="border-t-2 border-cp-encre">
                        {pc.stops?.map((s, i) => (
                            <div key={i} className="grid grid-cols-12 gap-4 py-6 md:py-8 border-b border-cp-border items-start" data-testid={`stop-${i}`}>
                                <span className="col-span-2 md:col-span-1 cp-serif italic text-cp-sable-deep text-2xl">{String(i + 1).padStart(2, "0")}</span>
                                <div className="col-span-10 md:col-span-9">
                                    <p className="cp-tiny text-cp-sable-deep mb-1">{KIND_LABEL[s.kind] || s.kind}{s.city_slug && ` · ${s.city_slug}`}</p>
                                    <h3 className="cp-serif text-2xl md:text-3xl leading-tight text-cp-encre mb-1">{s.name}</h3>
                                    {s.note && <p className="cp-serif italic text-base text-cp-gris">{s.note}</p>}
                                </div>
                                {s.lat && s.lng && (
                                    <span className="col-span-12 md:col-span-2 cp-tiny text-cp-gris flex md:justify-end items-start gap-1.5 pt-2">
                                        <MapPin size={12} strokeWidth={1.25} /> {s.lat.toFixed(3)}, {s.lng.toFixed(3)}
                                    </span>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}
